import React from "react";
import "./app_content_field_item4.css";

class AppContentFieldItem4 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      title: props.title,
      value: props.value,
    };
  }

  stateTitle() {
    return this.state.title;
  }
  stateValue() {
    console.log("The Card", this.state.title);
    let value = this.state.value;
    if (this.state.title.includes("Fund Pricing")) {
      if (this.state.value == "N/A") {
        value = this.state.value;
      } else {
        value = `RM ${value}`;
      }
    }
    // if (this.state.value.includes(".00")) {
    //   value = `RM ${value}`;
    // }
    return value;
  }

  componentDidMount() {}

  render() {
    return (
      <div className="app-content-field4">
        <div className="app-content-field-tag4 w-100">
          {this.stateValue() || ""}
        </div>
      </div>
    );
  }
}

export default AppContentFieldItem4;
